module.exports = __webpack_public_path__ + "static/mugs-42a832408bfa29bb5d45957e3a9a2565.jpeg";